<mbs-modal
  [isCustomModal]="true"
  [showFooter]="true"
  [title]="'wizards:what_backup_step_title' | i18next">
  <ng-container modal-body>
    @if (ready()) {
      @if (isImageBased()) {
        <mbs-what-backup-step [(ngModel)]="whatBackupStep"></mbs-what-backup-step>
      } @else {
        <mbs-what-backup-tree-step [(ngModel)]="whatBackupTreeStep"></mbs-what-backup-tree-step>
      }
    }
  </ng-container>

  <ng-container modalFooter>
    <mbs-button
      [type]="'primary'"
      (click)="saveClickHandler()">
      {{ 'shared:buttons.save' | i18next }}
    </mbs-button>

    <mbs-button
      data-dismiss="modal"
      [type]="'secondary'"
      (click)="cancelClickHandler()">
      {{ 'shared:buttons.cancel' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
